// Main JavaScript file
// Import modules for custom logic (Bootstrap handles components via data-attributes)

import Topbar from './modules/topbar';
import Navbar from './modules/navbar';
import Form from './modules/form';
import ImageUpload from './modules/image-upload';
import ProfileSidebar from './modules/profile-sidebar';
import Parallax404 from './modules/parallax-404';
import MusicPlayer from './modules/music-player';
// import ArtworkCard from './modules/artwork-card';
// import Footer from './modules/footer';
// Modal custom actions are in modal.js (auto-initialized via DOMContentLoaded)

// Initialize on DOM load
document.addEventListener('DOMContentLoaded', () => {
  console.log('World Art Atlas loaded');
  
  // Initialize components with custom logic
  initComponents();
});

function initComponents() {
  // Topbar - custom search logic (also handles navbar search)
  const topbars = document.querySelectorAll('.topbar');
  topbars.forEach(element => {
    new Topbar(element);
  });

  // Navbar - custom active link logic and search logic
  const navbars = document.querySelectorAll('.navbar');
  navbars.forEach(element => {
    new Navbar(element);
    // Also initialize Topbar for search handling in navbar
    new Topbar(element);
  });

  // Music Player - инициализация при открытии модального окна
  initMusicPlayer();

  // // Artwork Cards - custom modal opening and interactions
  // const artworkCards = document.querySelectorAll('.artwork-card');
  // artworkCards.forEach(element => {
  //   new ArtworkCard(element);
  // });

  // // Footer - custom logic if needed
  // const footers = document.querySelectorAll('.footer');
  // footers.forEach(element => {
  //   new Footer(element);
  // });
}

// Инициализация музыкального плеера
function initMusicPlayer() {
  const musicModal = document.getElementById('music-modal');
  if (!musicModal) return;

  let musicPlayerInstance = null;

  // Обработка клика на карточку для передачи ID музыканта
  document.addEventListener('click', (e) => {
    const card = e.target.closest('[data-bs-target="#music-modal"]');
    if (card && card.dataset.musicianId) {
      musicModal.dataset.musicianId = card.dataset.musicianId;
    }
  });

  // Инициализация при открытии модального окна
  musicModal.addEventListener('shown.bs.modal', () => {
    const playerElement = musicModal.querySelector('.music-modal__player');
    if (playerElement) {
      // Уничтожаем предыдущий экземпляр, если есть
      if (musicPlayerInstance) {
        musicPlayerInstance.destroy();
        musicPlayerInstance = null;
      }
      // Создаем новый экземпляр
      musicPlayerInstance = new MusicPlayer(playerElement);
    }
  });

  // Очистка при закрытии модального окна
  musicModal.addEventListener('hidden.bs.modal', () => {
    if (musicPlayerInstance) {
      musicPlayerInstance.destroy();
      musicPlayerInstance = null;
    }
  });
}

